import { Chain } from '@1delta/chain-registry'

export const MULTICALL_DEFAULT_BATCH_SIZE = 4096

// Uniswap interface Multicalls
const CELO_MULTICALL_ADDRESS = '0x633987602DE5C4F337e3DbF265303A1080324204'
const BNB_MULTICALL_ADDRESS = '0x963Df249eD09c358A4819E39d9Cd5736c3087184'
const MANTLE_MULTICALL_ADDRESS = '0x2A51f2F647E1883F88C992244dEd171238693107'
const ARBITRUM_ONE_MULTICALL_ADDRESS =
  '0xadF885960B47eA2CD9B55E6DAc6B42b7Cb2806dB'
const LINEA_MULTICALL_ADDRESS = '0xac1cE734566f390A94b00eb9bf561c2625BF44ea'
const AVALANCHE_MULTICALL_ADDRESS = '0x0139141Cd4Ee88dF3Cdb65881D411bAE271Ef0C2'
const BASE_MULTICALL_ADDRESS = '0x091e99cb1C49331a94dD62755D168E941AbD0693'
const BLAST_MULTICALL_ADDRESS = '0xdC7f370de7631cE9e2c2e1DCDA6B3B5744Cf4705'
const TAIKO_MULTICALL_ADDRESS = '0x8E24CfC19c6C00c524353CB8816f5f1c2F33c201'
const HEMI_MULTICALL_ADDRESS = '0x352A86168e6988A1aDF9A15Cb00017AAd3B67155'
const GNOSIS_MULTICALL_ADDRESS = '0x4dfa9a980efE4802E969AC33968E3d6E59B8a19e'
const MODE_MULTICALL_ADDRESS = '0xAB39cE30D98a59DFDa40A630b074170800bfF179'
const FANTOM_MULTICALL_ADDRESS = '0xDb51CffFf3B989d0cB6b58AbF173371b6F2d0D24'
const SCROLL_MULTICALL_ADDRESS = '0x3b615B1AC55bc34e51a81D3dea67467F32bcb8C2'
const SHAPE_MULTICALL_ADDRESS = '0x356A450B32f5030ae7083702b86FaFbBe7490411'
const SONIC_MULTICALL_ADDRESS = '0x5d6b0f5335ec95cD2aB7E52f2A0750dd86502435'
const INK_MULTICALL_ADDRESS = '0xA0fCec583AeE6176527C07B198e5561722332014'
const METIS_MULTICALL_ADDRESS = '0x7a59ddbB76521E8982Fa3A08598C9a83b14A6C07'
const IOTA_MULTICALL_ADDRESS = '0x9683D433621A83aA7dd290106e1da85251317F55'
const KAVA_MULTICALL_ADDRESS = '0x8B741B0D79BE80E135C880F7583d427B4D41F015'
const SAGA_MULTICALL_ADDRESS = '0x743E03cceB4af2efA3CC76838f6E8B50B63F184c'
const CYBER_MULTICALL_ADDRESS = '0x906d6eB9CF8f64e100e44f8f491b833a8d40B530'
const METAL_MULTICALL_ADDRESS = '0x5d6b0f5335ec95cD2aB7E52f2A0750dd86502435'
const ZERO_MULTICALL_ADDRESS = '0x9CA4dcb2505fbf536F6c54AA0a77C79f4fBC35C0'
const BOB_MULTICALL_ADDRESS = '0x5d6b0f5335ec95cD2aB7E52f2A0750dd86502435'
const WORLDCHAIN_MULTICALL_ADDRESS =
  '0x0a22c04215c97E3F532F4eF30e0aD9458792dAB9'
const LISK_MULTICALL_ADDRESS = '0xE3dbcD53f4Ce1b06Ab200f4912BD35672e68f1FA'
const REDSTONE_MULTICALL_ADDRESS = '0xd57B52452a0FDfE3ff8e0A40Bd10D00D0bfe0723'
const MANTA_MULTICALL_ADDRESS = '0x52dFC0D9960F11A9Ca9FF616e791B91188446a60'
const ZORA_MULTICALL_ADDRESS = '0xA51c76bEE6746cB487a7e9312E43e2b8f4A37C15'
const CORE_MULTICALL_ADDRESS = '0xFe9F82D820757787895Da00B1dBD35c3B8b04894'
const MORPH_MULTICALL_ADDRESS = '0xAcD82113982479B25E7c1D09858F0130921Dbbca'
const TELOS_MULTICALL_ADDRESS = '0x5d6b0f5335ec95cD2aB7E52f2A0750dd86502435'

/**
 * Uniswap Interface Multicall
 */
export const MULTICALL_ADDRESS: { [c: string]: string } = {
  [Chain.OP_MAINNET]: '0x1F98415757620B543A52E61c46B32eB19261F984',
  [Chain.POLYGON_MAINNET]: '0x1F98415757620B543A52E61c46B32eB19261F984',
  [Chain.ETHEREUM_MAINNET]: '0x1F98415757620B543A52E61c46B32eB19261F984',
  [Chain.ARBITRUM_ONE]: ARBITRUM_ONE_MULTICALL_ADDRESS,
  [Chain.BASE]: BASE_MULTICALL_ADDRESS,
  [Chain.CELO_MAINNET]: CELO_MULTICALL_ADDRESS,
  [Chain.BNB_SMART_CHAIN_MAINNET]: BNB_MULTICALL_ADDRESS,
  [Chain.MANTLE]: MANTLE_MULTICALL_ADDRESS,
  [Chain.BLAST]: BLAST_MULTICALL_ADDRESS,
  [Chain.LINEA]: LINEA_MULTICALL_ADDRESS,
  [Chain.AVALANCHE_C_CHAIN]: AVALANCHE_MULTICALL_ADDRESS,
  [Chain.TAIKO_ALETHIA]: TAIKO_MULTICALL_ADDRESS,
  [Chain.HEMI_NETWORK]: HEMI_MULTICALL_ADDRESS,
  [Chain.GNOSIS]: GNOSIS_MULTICALL_ADDRESS,
  [Chain.CORE_BLOCKCHAIN_MAINNET]: CORE_MULTICALL_ADDRESS,
  [Chain.METIS_ANDROMEDA_MAINNET]: METIS_MULTICALL_ADDRESS,
  [Chain.MODE]: MODE_MULTICALL_ADDRESS,
  [Chain.INK]: INK_MULTICALL_ADDRESS,
  [Chain.IOTA_EVM]: IOTA_MULTICALL_ADDRESS,
  [Chain.SONIC_MAINNET]: SONIC_MULTICALL_ADDRESS,
  [Chain.FANTOM_OPERA]: FANTOM_MULTICALL_ADDRESS,
  [Chain.SCROLL]: SCROLL_MULTICALL_ADDRESS,
  [Chain.SHAPE]: SHAPE_MULTICALL_ADDRESS,
  [Chain.CYBER_MAINNET]: CYBER_MULTICALL_ADDRESS,
  [Chain.ZORA]: ZORA_MULTICALL_ADDRESS,
  [Chain.MANTA_PACIFIC_MAINNET]: MANTA_MULTICALL_ADDRESS,
  [Chain.REDSTONE]: REDSTONE_MULTICALL_ADDRESS,
  [Chain.KAVA]: KAVA_MULTICALL_ADDRESS,
  [Chain.METAL_L2]: METAL_MULTICALL_ADDRESS,
  [Chain.LISK]: LISK_MULTICALL_ADDRESS,
  [Chain.BOB]: BOB_MULTICALL_ADDRESS,
  [Chain.ZERO_NETWORK]: ZERO_MULTICALL_ADDRESS,
  [Chain.SAGA]: SAGA_MULTICALL_ADDRESS,
  [Chain.MORPH]: MORPH_MULTICALL_ADDRESS,
  [Chain.TELOS_EVM_MAINNET]: TELOS_MULTICALL_ADDRESS,
  [Chain.WORLD_CHAIN]: WORLDCHAIN_MULTICALL_ADDRESS,
}
